module.exports = "<p>payout-structure works!</p>\n"